import React from "react";
import "./LayerControl.css";

function LayerControl({ activeLayer, onLayerChange, onCurrentLocation }) {
  return (
    <div className="custom-layer-control">
      <button
        id="street-view-btn"
        className={`layer-btn ${activeLayer === "street" ? "active" : ""}`}
        title="Street Map"
        onClick={() => onLayerChange("street")}
      >
        <i className="fa-solid fa-map-location-dot"></i>
      </button>
      <button
        id="satellite-view-btn"
        className={`layer-btn ${activeLayer === "satellite" ? "active" : ""}`}
        title="Satellite View"
        onClick={() => onLayerChange("satellite")}
      >
        <i className="fa-solid fa-satellite-dish"></i>
      </button>
      <button
        id="current-location-btn"
        className="layer-btn"
        title="My Location"
        onClick={onCurrentLocation}
      >
        <i className="fa-solid fa-location-crosshairs"></i>
      </button>
    </div>
  );
}

export default LayerControl;
